import React from 'react';
import styles from './StartListsEditor.module.css';

const AutoGenerateModal = ({
  isOpen,
  onClose,
  onGenerate
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.modalTitle}>
          Generate Heats
        </h3>

        <div className={styles.modalSection}>
          <div className={styles.modalDescription}>
            28 athletes to distribute
          </div>

          <label className={styles.modalLabel}>
            Number of heats: [4 ▼]
          </label>

          <div className={styles.radioGroup}>
            <label className={styles.modalLabel}>
              Seeding Method:
            </label>
            <label className={styles.radioOption}>
              <input type="radio" name="seeding" defaultChecked className={styles.radioInput} />
              <span className={styles.radioLabel}>Fastest heat last</span>
            </label>
            <label className={styles.radioOption}>
              <input type="radio" name="seeding" className={styles.radioInput} />
              <span className={styles.radioLabel}>Random</span>
            </label>
          </div>

          <div className={styles.radioGroup}>
            <label className={styles.modalLabel}>
              Lane Assignment:
            </label>
            <label className={styles.radioOption}>
              <input type="radio" name="lanes" defaultChecked className={styles.radioInput} />
              <span className={styles.radioLabel}>
                Fastest in center lanes
              </span>
            </label>
            <label className={styles.radioOption}>
              <input type="radio" name="lanes" className={styles.radioInput} />
              <span className={styles.radioLabel}>Random</span>
            </label>
          </div>
        </div>

        <div className={styles.modalActions}>
          <button
            onClick={onClose}
            className={styles.modalButton}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onGenerate();
              onClose();
            }}
            className={styles.modalButtonPrimary}
          >
            Generate
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoGenerateModal;
